import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Checkbox from "@material-ui/core/Checkbox";
import Avatar from "@material-ui/core/Avatar";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    background: "linear-gradient(135deg, #f9e7b3 0%, #f4d03f 100%)",
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  },
  listItem: {
    "&:hover": {
      backgroundColor: "rgba(241, 196, 15, 0.1)",
    },
  },
  avatar: {
    backgroundColor: "#f1c40f",
    color: "#ffffff",
  },
  checkbox: {
    color: "#f1c40f",
    "&.Mui-checked": {
      color: "#f1c40f",
    },
  },
}));

export default function CheckboxListSecondary({ attendance }) {
  const classes = useStyles();
  const [checked, setChecked] = React.useState([1]);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  return (
    <List dense className={classes.root}>
      {attendance &&
        attendance.map((value, index) => {
          const labelId = `checkbox-list-secondary-label-${index}`;
          return (
            <ListItem key={index} button>
              <ListItemAvatar>
                <Avatar
                  alt={`Avatar n°${index}`}
                  className={classes.avatar}
                  src={`/static/images/avatar/${index}.jpg`}
                />
              </ListItemAvatar>
              <ListItemText id={labelId} primary={value.student_name} />
              <ListItemSecondaryAction>
                <Checkbox
                  edge="end"
                  readOnly={true}
                  onChange={handleToggle(value)}
                  checked={value.present === "1" ? true : false}
                  // checked={checked.indexOf(value) !== -1}
                  className={classes.checkbox}
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
    </List>
  );
}
